import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=577addc4&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"
import style0 from "./Dropdown.scss?vue&type=style&index=0&id=577addc4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577addc4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotDropdownGroupsContent: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/DropdownGroup/DropdownGroupsContent.vue').default,HotDropdownNormalContent: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/DropdownNormalContent/DropdownNormalContent.vue').default})
